import React, { useReducer, useEffect, useContext } from "react";
import moduleConfig from "./moduleConfig";
import { Card, Row, Col } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";

import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import axios from "../../../config/axios";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";

import CMSFormInput from "../../UI/forms/CMSFormInput";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";

import CMSFormTextArea from "../../UI/forms/CMSFormTextArea";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormImageWithCrop from "../../UI/forms/CMSFormImageWithCrop";
import {
  createReducer,
  createInitialState,
} from "../../../reducers/module/createReducer";
import { onSubmitGeneral } from "../../../helpers/ModuleHelperFunctions";
import CMSFormDate from "../../UI/forms/CMSFormDate";
import CMSFormTime from "../../UI/forms/CMSFormTime";

const DiscountCouponCreate = () => {
  const [createState, createDispatch] = useReducer(
    createReducer,
    createInitialState
  );
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  let navigate = useNavigate();

  useEffect(() => {
    setBreadcrumb([
      moduleConfig.breadcrumbs.listing,
      moduleConfig.breadcrumbs.create,
    ]);
  }, []);

  var currentDate = new Date();
  var endDate = new Date();
  endDate.setDate(currentDate.getDate() + 5);

  return (
    <DashboardLayout>
      {createState.status === "fetchFailed" ? (
        <BlockErrorMessage error={createState.error} />
      ) : (
        <>
          {createState.status !== "fetching" && (
            <>
              <ModuleHeader
                moduleTitle={`Create ${moduleConfig.singleItemTitle}`}
                moduleUrl={moduleConfig.url}
              ></ModuleHeader>

              <section className="content">
                <Card>
                  <Card.Body>
                    {createState.isLoading && (
                      <div className="overlay position-absolute containerLoading">
                        <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                      </div>
                    )}
                    <Formik
                      initialValues={{
                        title: "",
                        couponCode: "",
                        discountFor: "Subscription",
                        discountType: "Percentage",
                        discountValue: "",
                        maxUsageLimit: 0,
                        minAmount: 0,
                        startDate: currentDate,
                        //startTime: "09:00",
                        endDate: endDate,
                        //endTime: "09:00",
                        description: "",
                        showOnHome: "1",
                        status: "0",
                      }}
                      validationSchema={yup.object({
                        title: yup
                          .string()
                          .required("Title is required")
                          .max(50, "Title cannot exceed 50 characters"),

                        couponCode: yup
                          .string()
                          .required("Coupon code is required")
                          .max(10, "Coupon code cannot exceed 10 characters"),

                        discountFor: yup
                          .string()
                          .required("Discount for is required"),

                        discountType: yup
                          .string()
                          .required("Discount type is required"),

                        discountValue: yup
                          .number()
                          .typeError("Discount value must be a number")
                          .required("Discount value is required"),

                        maxUsageLimit: yup
                          .number()
                          .typeError("Maximum usage limit must be a number")
                          .required("Maximum usage limit is required"),

                        minAmount: yup
                          .number()
                          .typeError("Minimum amount must be a number")
                          .required("Minimum amount is required"),

                        startDate: yup
                          .string()
                          .required("Start date is required"),

                        endDate: yup.string().required("End date is required"),

                        description: yup.string(),

                        showOnHome: yup.string().required("Want to show on website?"),
                        status: yup.string().required("Status is required"),
                      })}
                      enableReinitialize={true}
                      validateOnChange={true}
                      validateOnBlur={true}
                      onSubmit={async (values, { resetForm }) => {
                        await onSubmitGeneral(
                          values,
                          moduleConfig.url,
                          moduleConfig.url,
                          createDispatch,
                          navigate
                        );
                      }}
                    >
                      {(form) => (
                        <Form onSubmit={form.handleSubmit}>
                          {createState.error && (
                            <FormErrorMessage error={createState.error} />
                          )}

                          <CMSFormInput
                            name="title"
                            label="Title"
                            required={true}
                            form={form}
                          />

                          <CMSFormInput
                            name="couponCode"
                            label="Coupon Code"
                            required={true}
                            form={form}
                          />

                          <CMSFormSelect
                            name="discountFor"
                            label="Discount For"
                            form={form}
                             required={true}
                            options={[
                              { label: "Product", value: "Product" },
                              { label: "Subscription", value: "Subscription" },
                            ]}
                          />

                          <CMSFormSelect
                            name="discountType"
                            label="Discount Type"
                             required={true}
                            form={form}
                            options={[
                              { label: "Percentage", value: "Percentage" },
                              { label: "Fixed Value", value: "Fixed Value" },
                            ]}
                          />

                          <CMSFormInput
                            name="discountValue"
                            label="Discount Value"
                            required={true}
                            form={form}
                          />

                          <CMSFormInput
                            name="maxUsageLimit"
                            label="Max. Usage Limit"
                            info="Zero value for unlimited"
                            required={true}
                            form={form}
                          />

                          <CMSFormInput
                            name="minAmount"
                            label="Minimum Order Amount"
                            info="Zero value for any amount"
                            required={true}
                            form={form}
                          />

                          <CMSFormDate
                            name="startDate"
                            label="Start Date"
                            required={true}
                            form={form}
                            minDate={currentDate}
                             value={new Date(form.values["startDate"])}
                            // minDate={new Date(getPackageStartDate(activeClient))}
                            // maxDate={new Date(getPackageEndDate(activeClient))}
                            disabled={false}
                          />

                          {/* <CMSFormTime
                            name="startTime"
                            label="Start Time"
                            required={true}
                            form={form}
                          />   */}

                          <CMSFormDate
                            name="endDate"
                            label="End Date"
                            required={true}
                            form={form}
                             value={new Date(form.values["endDate"])}
                            minDate={currentDate}
                            // minDate={new Date(getPackageStartDate(activeClient))}
                            // maxDate={new Date(getPackageEndDate(activeClient))}
                            disabled={false}
                          />

                          {/* <CMSFormTime
                            name="endTime"
                            label="End Time"
                            required={true}
                            form={form}
                          />    */}
{/* 
                          <CMSFormTextArea
                            name="description"
                            label="Description"
                            form={form}
                            required={false}
                            maxLength={300}
                          /> */}

                          <CMSFormSelect
                            name="showOnHome"
                            label="Want to show on website?"
                            form={form}
                             required={true}
                            options={[
                              
                              { label: "Yes", value: "1" },
                              { label: "No", value: "0" },
                            ]}
                          />

                          <CMSFormSelect
                            name="status"
                            label="Status"
                            form={form}
                             required={true}
                            options={[
                              { label: "Select Status...", value: "" },
                              { label: "Enabled", value: "1" },
                              { label: "Disabled", value: "0" },
                            ]}
                          />

                          <button type="submit" className="btn btn-primary ">
                            Submit
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </section>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default DiscountCouponCreate;
